// Time-to-reset / "Resets in Nd" component
import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

function diffDays(iso) {
  if (!iso) return null;
  const target = new Date(iso).getTime();
  const now = Date.now();
  const ms = target - now;
  if (ms <= 0) return 0;
  return Math.ceil(ms / (24 * 60 * 60 * 1000));
}

function diffHours(iso) {
  if (!iso) return null;
  const target = new Date(iso).getTime();
  const now = Date.now();
  return Math.max(0, Math.ceil((target - now) / (60 * 60 * 1000)));
}

export default function ResetBadge({ periodEnd, label = "Resets", className = "", danger = false }) {
  const [, force] = useState(0);

  useEffect(() => {
    // Re-render once a minute so the countdown stays fresh
    const t = setInterval(() => force((n) => n + 1), 60 * 1000);
    return () => clearInterval(t);
  }, []);

  if (!periodEnd) return null;
  const days = diffDays(periodEnd);
  const hours = diffHours(periodEnd);

  let text;
  if (days === 0) text = hours <= 1 ? "in <1h" : `in ${hours}h`;
  else if (days === 1) text = "tomorrow";
  else if (days <= 7) text = `in ${days}d`;
  else text = `in ${days}d`;

  const isUrgent = danger || (days !== null && days <= 3);
  return (
    <span
      className={`inline-flex items-center gap-1 text-[11px] uppercase tracking-[0.14em] ${className}`}
      style={{ color: isUrgent ? "#f97316" : undefined }}
    >
      <Clock className="h-3 w-3" />
      {label} {text}
    </span>
  );
}
